import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExternalScriptsService {

  private loadedScripts: { [key: string]: boolean } = {};

  constructor() { }

  loadScript(id: string, src: string, attributes: {[key: string]: string} = {}) {

    // Evita cargar algo dos veces
    if (this.loadedScripts[id]) return;

    const script = document.createElement('script');
    script.src = src;
    script.id = id;

    // Agregar atributos extra
    Object.keys(attributes).forEach(key => {
      script.setAttribute(key, attributes[key]);
    });

    document.body.appendChild(script);
    this.loadedScripts[id] = true;
  }

  removeScript(id: string) {
    const script = document.getElementById(id);
    if (script) {
      script.remove();
      this.loadedScripts[id] = false;
    }
  }

  loadLoggedWidget() {
    this.loadScript(
      'widget-login',
      'https://beta.leadconnectorhq.com/loader.js',
      {
        'data-resources-url': 'https://beta.leadconnectorhq.com/chat-widget/loader.js',
        'data-widget-id': '692a08015d98db6cdc4d269b'
      }
    );
  }

  loadNotLoggedWidget() {
    this.loadScript(
      'widget-no-login',
      'https://widgets.leadconnectorhq.com/loader.js',
      {
        'data-resources-url':"https://widgets.leadconnectorhq.com/chat-widget/loader.js",
        'data-widget-id':"69416a1b4ca182732f9b5734"
      }
    );
  }
}
